export default __webpack_public_path__ + "static/BrownEntrataTT-Italic-70697b77152889bcfc8e13872f0f4b25.ttf";